// extracted by mini-css-extract-plugin
export var closeButton = "_8z-0";